// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"RecipientsMappingPopup_saveButton__QKOM_","additionalInputsSection":"RecipientsMappingPopup_additionalInputsSection__2E4PW"};